import {Keyboard, KeyboardResize, KeyboardInfo} from '@capacitor/keyboard';
import {PluginListenerHandle} from '@capacitor/core';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from "./services/utils.service";
import {Router} from "@angular/router";
import {GlobalStorageService} from "./services/global-storage.service";
import {StorageService} from "./services/storage.service";
import {RESTService} from "./services/rest.service";
import {IndexedDB} from "./services/indexed-db.service";
import {APIService} from "./services/api.service";
import {firstValueFrom, zip} from "rxjs";
import {Network} from "@capacitor/network";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private keyboardWillShowListener: PluginListenerHandle | null = null;
  private keyboardWillHideListener: PluginListenerHandle | null = null;
  isNotificationAlertOpen: boolean = false;
  notificationAlertButtons: any = [{
    text: 'Cancel',
    cssClass: 'grey two-buttons',
    handler: (data: any) => {
    }
  },
    {
      text: 'Stop Timer',
      cssClass: 'red two-buttons',
      handler: (data: any) => {
        this.stop();
      }
    }
  ];

  isClockModalOpen: boolean = false;
  clock: any = {};
  skipCheckInterval: any = null;
  autoCloseDayInterval: any = null;
  //uploadSyncDataSub: any = {};
  isSyncErrorAlertOpen: boolean = false;
  noClockInPages: any = ['login', 'signature'];
  urlParameters: any;
  // lastUpdateDate: any;
  clockTime: any;
  isSkipButtonActive: boolean = false;
  timeInterval: any = {};
  isSendAllFiles: boolean = false;

  constructor(
    private router: Router,
    private utils: UtilsService,
    public global: GlobalStorageService,
    private storage: StorageService,
    private rest: RESTService,
    private db: IndexedDB,
    private api: APIService) {
    this.global.set('clock', {});
    const isBackSyncRequired = this.storage.getItem('isBackSyncRequired');
    this.global.set('isBackSyncRequired', isBackSyncRequired || isBackSyncRequired === 'true');
    this.isSendAllFiles = Boolean(this.storage.getItem('isSendAllFiles'));
    /*
        window.addEventListener('online', () => {
          this.global.set('isOffline', false);
        });
        window.addEventListener('offline', () => {
          this.global.set('isOffline', true);
        });
    */
    this.runAutoCloseDay();

    this.checkIsBackSyncRequired();

    this.clock = this.storage.getItem('clock');
    if (this.clock) {
      this.global.set('clock', this.clock);
      this.clock.startDate = new Date(this.clock.startDate);
      this.clock._createdDate = new Date(this.clock._createdDate);
    }
    clearInterval(this.timeInterval);
    this.timeInterval = setInterval(() => {
      this.checkIsSkipButtonActive();
      //this.checkClockStatus();
      this.checkClockTime();
      this.urlParameters = this.router.url.split('/') || [];
    }, 1000);

    this.utils.checkNetworkStatus();
    Network.addListener('networkStatusChange', status => {
      this.global.set('networkStatus', status);
      this.global.set('isOffline', !status?.connected);
    });
  }

  async ngOnInit() {
    if (this.utils.isNative()) {
      await Keyboard.setResizeMode({mode: KeyboardResize.Ionic});

      this.keyboardWillShowListener = await Keyboard.addListener('keyboardWillShow', (info: KeyboardInfo) => {
        console.log('Keyboard will show. Height:', info.keyboardHeight);
      });

      this.keyboardWillHideListener = await Keyboard.addListener('keyboardWillHide', () => {
        console.log('Keyboard will hide');
      });
    }
  }

  ngOnDestroy() {
    if (this.utils.isNative()) {
      if (this.keyboardWillShowListener) {
        this.keyboardWillShowListener.remove();
      }
      if (this.keyboardWillHideListener) {
        this.keyboardWillHideListener.remove();
      }
    }
  }

  async hideKeyboard() {
    await Keyboard.hide();
  }


  async checkIsBackSyncRequired() {
    const notClosedVisits: any = await this.readNotClosedVisits()
    const now = this.utils.getPacificDate();
    const today = now.toISOString().substring(0, 10);
    let yesterdaysVisits: any = [];
    if (notClosedVisits.visits?.length) {
      yesterdaysVisits = notClosedVisits.visits.filter((item: any) => {
        return item.finishDate.toISOString().substring(0, 10) !== today;
      });
    }

    if (yesterdaysVisits?.length) {
      this.storage.setItem('isBackSyncRequired', 'true');
      this.storage.setItem('isBackSyncRequiredModal', 'true');
      await this.api.closeDay();
      this.storage.setItem('closedDayDate', this.utils.getPacificDateISO(yesterdaysVisits[0].finishDate).substring(0, 10));
      //await this.uploadSyncData();
      this.router.navigate(['/tasks']);
    } else {
      await this.navigateUser();
    }
  }

  async navigateUser() {
    const siteVisit: any = this.storage.getItem('siteVisit');
    const visitType: any = this.storage.getItem('visitType');
    if (siteVisit?._id && siteVisit?.siteVisitId && visitType) {
      const visit: any = await this.db.readItem('visits', siteVisit?.siteVisitId);
      if (visit?.id) {
        if (visit.routeType === 'Scheduled') {
          if (visit.startDate) {
            this.router.navigate([`/routes/sites/${siteVisit?.siteVisitId}/visit/${siteVisit?._id}/${visitType}`]);
          }
        } else if (visit.status === 'Completed') {
          if (visit.isClosed) {
            this.storage.setItem('previousPage', '/dashboard');
            this.storage.setItem('site', visit.site);
            this.router.navigate([`routes/sites/${visit.route.id}/visit/${visit.site._id}/${visitType}/site-visit/report`]);
          } else {
            this.router.navigate([`/routes/finished/${visit.route.id}/site/${visit.site._id}/site-info`]);
          }
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
    } else {
      if (Boolean(this.storage.getItem('isBackSyncRequiredModal'))) {
        this.router.navigate(['/tasks']);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  async readNotClosedVisits() {
    return new Promise(async (resolve, reject) => {
      const routes: any = await this.db.readItems('routes');
      const visits: any = [];
      routes.forEach((route: any) => {
        for (let visit of route?.visits) {
          if (!visit.isClosed && visit.status === 'Completed') {
            visits.push(visit);
          }
        }
      });

      resolve({visits: visits});
    });
  }

  async runAutoCloseDay() {
    const self = this;
    await this.autoCloseDay();
    clearInterval(this.autoCloseDayInterval);
    this.autoCloseDayInterval = setInterval(async () => {
      await self.autoCloseDay();
    }, 60000);
  }

  async autoCloseDay() {
    const now = this.utils.getPacificDate();
    let closeHours = 2;
    let closeMinutes = 0;
    const dev: any = this.storage.getItem('dev');
    if (dev?.closeDayTime) {
      closeHours = parseInt(dev.closeDayTime.split(":")[0]);
      closeMinutes = parseInt(dev.closeDayTime.split(":")[1]);
    }

    if (now.getHours() === closeHours && now.getMinutes() === closeMinutes) {
      const notClosedVisits: any = await this.readNotClosedVisits();
      if (notClosedVisits.visits?.length) {
        await this.api.closeDay();
        await this.onSyncStart();
        //this.router.navigate(['/tasks']);
      } else {
        const closedDayDate = this.storage.getItem('closedDayDate');
        const now = this.utils.getPacificDateISO(this.utils.getPacificDate()).substring(0, 10);
        if (Boolean(this.storage.getItem('isBackSyncRequired')) &&
          closedDayDate &&
          closedDayDate !== now) {
          await this.onSyncStart();
        }
      }
    }
  }

  async onSyncStart() {
    return new Promise(async (resolve, reject) => {
      const assignedTruck: any = await this.rest.readTrucks();
      if (assignedTruck?.assignedTruckID) {
        await this.uploadSyncData();
      }
      resolve({message: 'OK'});
    });
  }

  uploadSyncData() {
    return new Promise(async (resolve, reject) => {
      let alertMessage = '';
      const self = this;
      this.global.set('isLoading', true);
      const isSendAllFiles = this.storage.getItem('isSendAllFiles') === 'true';
      this.api.readSyncData(30, isSendAllFiles).then(async (syncData: any) => {
        try {
          let obsArray = [];
          let response: any = {};
          let isError: boolean = false;
          if (syncData.routes?.length) {
            response = await firstValueFrom(this.rest.uploadSyncData('routes', {
              routes: syncData.routes
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Routes';
            }
          }
          if (syncData.sites?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('sites', {
              sites: syncData.sites
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Sites';
            }
          }
          if (syncData.visits?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('visits', {
              visits: syncData.visits
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Visits';
            }
          }
          if (syncData.truckInventories?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('truck-inventory',
              syncData.truckInventories
            ));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Truck inventory';
            }
          }
          if (syncData.questionsTemplates?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('questions-templates', {
              questionsTemplates: syncData.questionsTemplates
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Questions Templates';
            }
          }

          if (syncData.services?.length && syncData.servicesComments?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('services', {
              services: syncData.services,
              servicesComments: syncData.servicesComments
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Services';
            }
          }

          if (syncData.trainings?.length && syncData.trainingsComments?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('trainings', {
              trainings: syncData.trainings,
              trainingsComments: syncData.trainingsComments
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Trainings';
            }
          }

          if (syncData.questions?.length && syncData.questionsComments?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('flow', {
              questions: syncData.questions,
              questionsComments: syncData.questionsComments
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Flow';
            }
          }

          if (syncData.questionsTemplates?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('questions-templates', {
              questionsTemplates: syncData.questionsTemplates
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Questions Templates';
            }
          }

          if (syncData.educationModules?.length && syncData.educationModulesComments?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('education-modules', {
              educationModules: syncData.educationModules,
              educationModulesComments: syncData.educationModulesComments
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Education Modules';
            }
          }

          if (syncData.inventories?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('inventory', {
              inventories: syncData.inventories
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Inventory';
            }
          }

          if (syncData.clockInOut?.length && !isError) {
            response = await firstValueFrom(this.rest.uploadSyncData('time-control', {clockInOut: syncData.clockInOut}));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Time Control';
            }
          }

          if (!isError && syncData.notes?.length) {
            response = await firstValueFrom(self.rest.uploadSyncData('notes', {
              notes: syncData.notes
            }));
            if (response?.message !== 'OK!') {
              isError = true;
              alertMessage = 'Notes';
            }
          }
          if (syncData.notes?.length && !isError) {
            response = await self.api.uploadFiles(syncData.notesWithFiles);
            if (response?.message !== 'All files were uploaded' && response?.message !== 'No files to upload') {
              isError = true;
              alertMessage = 'Files';
            }
          }

          if (isError) {
            alert(`Error during uploadind "${alertMessage}" data`);
            this.isSyncErrorAlertOpen = true;
            this.global.set('isLoading', false);
            reject({message: 'Something went wrong'});
          } else {
            if (syncData.visitsToSync?.length) {
              if (this.isSendAllFiles) {
                await this.db.createItem('lastUpdate', {
                  'id': 1,
                  date: this.utils.getPacificDate()
                });
              } else {
                await this.db.createItem('lastUpdate', {
                  'id': 1,
                  date: new Date(syncData.visitsToSync[syncData.visitsToSync.length - 1]._updatedDate)
                });
              }
            }

            this.storage.setItem('isBackSyncRequired', 'false');
            this.global.set('isBackSyncRequired', false);
            this.storage.setItem('closedDayDate', '');
            this.isSyncErrorAlertOpen = false;
            resolve({message: 'Data back synchronization completed'});
          }
          this.global.set('isLoading', false);
        } catch (e) {
          this.isSyncErrorAlertOpen = true;
          this.global.set('isLoading', false);
          reject({'message': 'Something went wrong'});
        }
      }).catch((error: any) => {
        this.isSyncErrorAlertOpen = true;
        this.global.set('isLoading', false);
        reject(error);
      });
    });
  }

  openClockModal() {
    this.isClockModalOpen = true;
  }

  onWillDismiss() {
    this.isClockModalOpen = false;
  }

  canDismiss() {
    return !this.isSkipButtonActive || this.clock.isSkipped;
  }

  checkClockTime() {
    const clock = this.global.get('clock') || {};
    if (clock && clock.startDate) {
      this.clockTime = this.utils.getDuration(this.utils.getPacificDate().getTime() - clock.startDate.getTime());
    } else {
      this.clockTime = '';
    }
  }

  checkIsSkipButtonActive() {
    let response = false;
    this.clock = this.global.get('clock') || {};
    const noSkipInPages = ['login'];
    const urlParameters = this.router.url.split('/');
    if (!noSkipInPages.includes(urlParameters[urlParameters.length - 1]) && this.clock && this.clock.startDate) {
      response = (this.clock.status === 'started' && !this.clock.isSkipped && !this.clock.totalMeal && ((this.clock.totalWork || 0) + (this.utils.getPacificDate().getTime() - this.clock.startDate.getTime())) >= 16200000); //4.5h
      if (response) {
        this.onClockClick();
      }
    }
    this.isSkipButtonActive = response;
  }

  async start() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};

    const clockInOutToday: any = await this.api.readClockInOutToday();
    this.clock.totalWork = clockInOutToday.total || 0;
    this.clock.isSkipped = clockInOutToday.isSkipped || false;

    this.clock.status = 'started';
    this.clock.type = 'work';
    this.clock.startDate = this.utils.getPacificDate();
    this.clock.endDate = "";
    this.clock.skipDate = null;
    this.clock.id = this.utils.getUUIDv4();

    this.db.createItem('clockInOut', this.clock).then((data: any) => {
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
    });
  }

  async lunch() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};

    const clockInOutToday: any = await this.api.readClockInOutToday();
    this.clock.totalWork = clockInOutToday.total || 0;
    this.clock.isSkipped = clockInOutToday.isSkipped || false;

    this.clock.status = 'lunch';
    this.clock.type = 'meal';
    this.clock.startDate = this.utils.getPacificDate();
    this.clock.endDate = "";
    this.clock.skipDate = null;
    this.clock.isSkipped = false;
    this.clock.id = this.utils.getUUIDv4();

    this.db.createItem('clockInOut', this.clock).then((data: any) => {
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
    });
  }

  stop() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};
    this.clock.status = 'stopped';
    this.clock.endDate = this.utils.getPacificDate();
    this.db.updateItem('clockInOut', this.clock.id, this.clock).then((data: any) => {
      this.isClockModalOpen = false;
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
    });
  }

  pause() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};
    this.clock.status = 'lunch';
    this.clock.endDate = this.utils.getPacificDate();
    this.db.updateItem('clockInOut', this.clock.id, this.clock).then((data: any) => {
      this.isClockModalOpen = false;
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
      this.lunch();
    });
  }

  resume() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};
    this.clock.status = 'stopped';
    this.clock.endDate = this.utils.getPacificDate();
    this.db.updateItem('clockInOut', this.clock.id, this.clock).then((data: any) => {
      this.isClockModalOpen = false;
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
    });
  }

  skip() {
    this.global.set('isLoading', true);
    this.clock = this.global.get('clock') || {};
    this.clock.skipDate = this.utils.getPacificDate();
    this.clock.isSkipped = true;
    this.db.updateItem('clockInOut', this.clock.id, this.clock).then((data: any) => {
      this.isClockModalOpen = false;
      this.global.set('clock', this.clock);
      this.storage.setItem('clock', this.clock);
      this.global.set('isLoading', false);
    });
  }

  onClockClick() {
    if (
      !this.router.url.includes("routes/sites/") &&
      !this.router.url.includes("routes/new/") &&
      !this.router.url.includes("routes/active/") &&
      !this.router.url.includes("routes/finished/")) {
      this.isClockModalOpen = true;
    }
  }

  get showClockFooter(): boolean {
    // This is the complex logic that determines if the footer should be shown
    const currentPage = this.urlParameters?.[this.urlParameters.length - 1];
    return !this.isClockModalOpen &&
      !!this.urlParameters &&
      !this.noClockInPages.includes(currentPage) &&
      this.global.data.clock.status !== 'stopped' &&
      !!this.global.data.clock.startDate;
  }

  get clockFooterClass(): string {
    // This getter returns the class string based on the showClockFooter logic
    return this.showClockFooter ? 'show-clock' : 'hide-clock';
  }

}
